import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["rootLevel", "renderLevels"];
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import useDropdownContext from './useDropdownContext';
const displayName = 'DropdownLevels';
const DropdownLevels = _ref => {
  let {
      rootLevel,
      renderLevels
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [level, setLevel] = useState([rootLevel]);
  const {
    toggle
  } = useDropdownContext({});
  const goToLevel = useCallback(newLevel => {
    const isNewLevelAlreadyInStack = level.lastIndexOf(newLevel);
    isNewLevelAlreadyInStack > 0 ? setLevel(level.slice(isNewLevelAlreadyInStack)) : setLevel([newLevel, ...level]);
  }, [level]);
  const goBack = useCallback(() => level.length > 1 && setLevel(level.slice(1)), [level]);
  return (
    /*#__PURE__*/
    /*
     * Don't remove this fragment. This is necessary for the documentation script to generate a section about this component.
     * It's a bug in `react-docgen` lib. Related issues: https://github.com/reactjs/react-docgen/issues/336
     */
    React.createElement(React.Fragment, null, renderLevels && renderLevels(Object.assign({
      level: level[0],
      goToLevel,
      goBack,
      toggle
    }, rest)))
  );
};
DropdownLevels.displayName = displayName;
DropdownLevels.propTypes = {
  /**
   * Sets the first level to be rendered.
   */
  rootLevel: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  /**
   * Function responsible to render the multiple `Dropdown` levels.
   *
   * @param {Object} props - The props that will be passed to the inner component.
   * @param {string|number} props.level - Returns the level to be rendered.
   * @param {Function} props.goToLevel - Function that triggers the render of a specific level. A level name needs to be passed as argument.
   * @param {Function} props.goBack - Function that triggers the last level render.
   * @param {Function} props.toggle - Function that opens or closes the `Dropdown`.
   */
  renderLevels: PropTypes.func.isRequired
};
export default DropdownLevels;